import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';

export const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [userInfo, setUserInfo] = useState({
    profileImageUrl: null,
    userType: null,
    isAuthenticated: false,
    role: null,
  });

  useEffect(() => {
    const checkAuth = async () => {
      try {
        
        const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/check-login-status`, {
          method: 'GET',
          credentials: 'include', 
        });


        if (response.ok) {
          const data = await response.json();
          
          if (data.isLoggedIn && data.user) {
            setUserInfo({
              ...data.user,
              isAuthenticated: true,
            });
            setIsAuthenticated(true);
          } else {
            setIsAuthenticated(false);
            setUserInfo({
              profileImageUrl: null,
              userType: null,
              isAuthenticated: false,
              role: null,
            });
          }
        } else {
          setIsAuthenticated(false);
          setUserInfo({
            profileImageUrl: null,
            userType: null,
            isAuthenticated: false,
            role: null,
          });
        }
      } catch (error) {
        setIsAuthenticated(false);
        setUserInfo({
          profileImageUrl: null,
          userType: null,
          isAuthenticated: false,
          role: null,
        });
      }
    };

    checkAuth();
  }, []);

  const logout = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/logout`, {
        method: 'POST',
        credentials: 'include',
      });

      if (response.ok) {
        Cookies.remove('manu');
        Cookies.remove('userInfo');
        setUserInfo({
          id: null,
          email: null,
          userType: null,
          profileImageUrl:null,
        });
        setIsAuthenticated(false);
        window.location.href = '/';
      } 
    } catch (error) {
      console.error('❌ AuthContext: Error logging out:', error);
    }
  };

  const login = async (userInfo) => {
    setUserInfo(userInfo); 
    setIsAuthenticated(true);
    
    // Fetch complete user info from backend to get role and other details
    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_STAGING_URL}/api/check-login-status`, {
        method: 'GET',
        credentials: 'include', 
      });

      if (response.ok) {
        const data = await response.json();
        
        if (data.isLoggedIn && data.user) {
          setUserInfo({
            ...data.user,
            isAuthenticated: true,
          });
        }
      }
    } catch (error) {
      console.error('❌ AuthContext: Error fetching user info after login:', error);
    }
    
    // Dispatch event to notify components that login is complete
    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('userLoggedIn', { detail: userInfo }));
    }, 100); // Small delay to ensure state is updated
  };


  return (
    <AuthContext.Provider
      value={{
        isAuthenticated,
        logout,
        userInfo,
        setUserInfo,
        login,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
